module.exports = __webpack_public_path__ + "img/603786.85e21fee.svg";